module.exports = __webpack_public_path__ + "img/homepage.1197b5e2.jpg";